import { useLazyQuery } from "@apollo/client";

import { GET_RECIPE_AND_INGREDIENTS_GROCERY_LIST } from "../../app/graphql/queries";
import { GetRecipeAndIngredientsGroceryListQuery } from "./useLazyRecipeAndIngredientsGroceryList.type";

const useLazyRecipeAndIngredientsGroceryList = () => {
  const [fetchIngredientsAndIngredientsSubsteps] = useLazyQuery<GetRecipeAndIngredientsGroceryListQuery['data'], GetRecipeAndIngredientsGroceryListQuery['variables']>(GET_RECIPE_AND_INGREDIENTS_GROCERY_LIST);

  const getRecipeAndIngredientsGroceryList = async (recipesData: {
    id: string,
    mealPlanId: string
    mealType: string,
    recipeId: string,
    scheduledDateTime: string,
    servingSize: number,
    status: string,
  }[]) => {
    const { data: fetchedRecipeData } = await fetchIngredientsAndIngredientsSubsteps({
      variables: { recipeIds: recipesData.map(recipe => recipe.recipeId) }
    })
    const recipesMealDataMap: Record<string, {
      id: string,
      mealPlanId: string
      mealType: string,
      recipeId: string,
      scheduledDateTime: string,
      servingSize: number,
      status: string,
    }> = {};
    recipesData.forEach((recipe) => {
      recipesMealDataMap[recipe.recipeId] = recipe;
    });

    const recipes = fetchedRecipeData?.Recipes_E3.map((recipe) => {
      const substeps: any[] = [];

      recipe.Recipe_Variations.forEach((variation) => {

        variation.RecipeVariations_Steps.forEach((step: any) => {
          step.StepsE3.Steps_Substeps.forEach((substep: any) => {
            substeps.push(substep.SubstepsE3);
          });
        });
      });
      return {
        recipeId: recipe.id,
        substeps,
        mealId: recipesMealDataMap[recipe.id].id,
        mealPlanId: recipesMealDataMap[recipe.id].mealPlanId,
        servingSize: recipesMealDataMap[recipe.id].servingSize,
      };
    });

    return recipes;

  }

  return { getRecipeAndIngredientsGroceryList };
}

export default useLazyRecipeAndIngredientsGroceryList